/**
 * 全局过滤器
 */
 // 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
export function formatDate(time,format) {
    if(parseInt(time) == 0 || isNaN(parseInt(time))){
       return '';
    }
    var times = new Date(parseInt(time + '000'));
    var year = times.getFullYear().toString();
    var month = times.getMonth()+1;
    var day = times.getDate();
    var hour = times.getHours();
    var minute = times.getMinutes();
    var second = times.getSeconds();
    var o = {
        "M+" : month,                 //月份
        "d+" : day,                    //日
        "h+" : hour,                   //小时
        "m+" : minute,                 //分
        "s+" : second                //秒
        // "q+" : Math.floor((date.getMonth()+3)/3), //季度
        // "S"  : date.getMilliseconds()             //毫秒
      };
    if(/(y+)/.test(format)) {
       format=format.replace(RegExp.$1, year.substr(4 - RegExp.$1.length));
    }
    for(var k in o)
    if(new RegExp("("+ k +")").test(format)){
        format = format.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    }
    return format;
}

export function gender(gender){
    gender = parseInt(gender);
    var list = ['', '男', '女'];
    return list[gender];
}

export function userRole(value){
    switch(parseInt(value)){
        case 10:
            return '博物馆';
        case 20:
            return '设计师';
        case 30:
            return '衍生品生产商';
        case 40:
            return '作品提供商';
        default:
            return '';
    }
}
export function authStatus(value){
    switch(parseInt(value)){
        case 10:
            return '未认证';
        case 20:
            return '待审核';
        case 30:
            return '已认证';
        case 40:
            return '未通过';
        default:
            return '';
    }
}

export function checkStatus(value){
    switch(parseInt(value)){
        case 10:
            return '待审核';
        case 20:
            return '未通过';
        case 30:
            return '授权中';
        case 40:
            return '授权失败';
        case 50:
            return '已授权';
        default:
            return '';
    }
}
export function orderStatus(value){
    switch(parseInt(value)){
        case 10:
            return '待完成';
        case 20:
            return '已完成';
        case 30:
            return '取消';
        default:
            return '';
    }
}
export function artworkAuthStatus(value){
    switch(parseInt(value)){
        case 10:
            return '待完成';
        case 20:
            return '已完成';
        case 30:
            return '取消';
        default:
            return '';
    }
}
export function authType(value){
    switch(parseInt(value)){
        case 10:
            return '个人认证';
        case 20:
            return '企业认证';
        default:
            return '';
    }
}
export function isShow(value){
    switch(parseInt(value)){
        case -1:
            return '已下架';
        case 1:
            return '已上架';
        default:
            return '';
    }
}
export function isRecommend(value){
    switch(parseInt(value)){
        case -1:
            return '否';
        case 1:
            return '是';
        default:
            return '';
    }
}
export function fmtBool(name){
    if (name == 1) {
        return '是';
    }

    return '否';
}

export function fmtId(name){
    if (name == 1) {
        return '身份证';
    }
    if (name == 2) {
        return '学生证';
    }
    if (name == 3) {
        return '其他';
    }
    return 'xx';
}


export function numberToChina(num){
    var china = "零,一,二,三,四,五,六,七,八,九,十";
    var chinaArray = china.split(',');
    return chinaArray[num];
}
export function sexToText(sex){
    const sexArr = ['','男','女','未知'];
    return sexArr[sex]
}
export function timestampToTime(timestamp) {
    var date = new Date(timestamp *1 );//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    if(timestamp.length==10){
        date = new Date(timestamp * 1000);
    }
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = date.getDate() + ' ';
    // var h = date.getHours() + ':';
    // var m = date.getMinutes() + ':';
    // var s = date.getSeconds();
    return Y+M+D;
}



// WEBPACK FOOTER //
// ./src/utils/filters.js